import { NgModule } from '@angular/core';
import { DatePickerE11Component } from './date-picker-e11.component';



@NgModule({
  declarations: [DatePickerE11Component],
  imports: [
  ],
  exports: [DatePickerE11Component]
})
export class DatePickerE11Module { }
